import { Stack } from "@mui/material";
import { Typography } from "@chr/eds-react";
import { Job } from "../../common/apis/dtos";
import { useTranslation } from "@chr/online-shared-ui-localizations";
import { ContainerDetailsSummary } from "./ContainerDetailsSummary";

export interface ContainerDetailsProps {
  shipment: Job;
  isMobileScreen: boolean;
}

export const ContainerDetails = ({shipment, isMobileScreen }: ContainerDetailsProps) => {
  const translate = useTranslation();
  const containerComponents = shipment.containers.map((container, index) => (
    <ContainerDetailsSummary
      key={index}
      sequenceNumber={index + 1}
      totalContainerCount={shipment.containers.length}
      containerInfo={container}
      isMobileScreen={isMobileScreen}
    />
  ));

  return (
    <Stack spacing={3} padding={1} className={isMobileScreen ? 'mobile': ''} data-testid="shipment-container-details-tab">
      <Typography variant="h2">{translate('Container Details')}</Typography>
      {containerComponents}
    </Stack>
  );
};

export default ContainerDetails;
